import React from "react";
import classes from './Loader.module.css';

const Loader = () => {
    return (<span className={classes.Loader}></span>)
}

export default Loader;